import { render, staticRenderFns } from "./buypackage.vue?vue&type=template&id=f99c4ab4&scoped=true"
import script from "./buypackage.vue?vue&type=script&lang=js"
export * from "./buypackage.vue?vue&type=script&lang=js"
import style0 from "./buypackage.vue?vue&type=style&index=0&id=f99c4ab4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99c4ab4",
  null
  
)

export default component.exports